import { Icon } from '@purpur/library/icon';
import styled from 'styled-components';

import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { DisneyLogoRound } from './DisneyLogoRound';

export const DisneyIconModeDesktop = styled(DisneyLogoRound)``;
export const DisneyIconModeMobile = styled(Icon).attrs({ size: 'md' })``;

export const DualMode = styled.span.attrs({ role: 'presentation' })`
    ${purpurMedia('sm')`
        ${DisneyIconModeDesktop} { display: none; }
        ${DisneyIconModeMobile} { display: flex; }
    `}
    ${purpurMedia('lg')`
        ${DisneyIconModeDesktop} { display: flex; }
        ${DisneyIconModeMobile} { display: none; }
    `}
`;
